import { Box, Typography } from "@mui/material";
import React from "react";
import TransferList from "./TransferList";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { setState } from "./editScenarioNewSlice";

export default function SkuPgSearchResult() {
	const dispatch = useDispatch();
	const setupState = useSelector((store) => store.editScenarioNew);
	const { productGroups, selectedPGs, editScDetails } = setupState;

	useEffect(() => {
		if (editScDetails !== null) {
			// let tempPGs = [];
			// editScDetails.productGroup.forEach((item) => {
			// 	console.log(item);
			// 	tempPGs.push(item.productGroup);
			// });
			// editScDetails.product.forEach((item) => {
			// 	console.log(item);
			// 	tempPGs.push(item.product);
			// });
			// dispatch(setState("selectedPGs", tempPGs));
		}
	}, [editScDetails]);
	return (
		<Box
			sx={{
				mt: 1,
				p:2,
				borderLeft: 1,
				borderColor: "#c6c6c6"
			}}
		>
			<Box sx={{}}>
				<Typography variant="subtitle1"></Typography>
			</Box>

			<Box container sx={{ mt: 1, justifyContent: "space-between"}}>
				<TransferList sx={{justifyContent: "space-between",}}
					leftList={productGroups}
					rightList={selectedPGs}
					leftState={"productGroups"}
					rightState={"selectedPGs"}
					isCustomer = {false}
				/>
			</Box>
		</Box>
	);
}
